import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import KitoMascot from '../../components/Mascot';
import { useNavigate, useParams } from 'react-router';
import KitoButton from '../../components/Inputs/KitoButton';

const congratsMessagesKeys = {
  ors: 'staticPages.newSkills.congratulations.ors',
  medicine: 'staticPages.newSkills.congratulations.medicine',
  inhaler: 'staticPages.newSkills.congratulations.inhaler',
};

function Congratulations() {
  const { t } = useTranslation();
  const params = useParams();
  const skill = params.skill || 'ors';

  const congratsMessages = ['Congratulations', t(congratsMessagesKeys[skill])];
  const navigate = useNavigate();

  return (
    <div className={styles.skillStaticPage__congratulations}>
      <KitoMascot>
        <div className={styles.skillStaticPage__congratulations__content}>
          {congratsMessages.map((message, index) => (
            <p
              key={message}
              className={clsx(
                styles.skillStaticPage__congratulations__text,
                styles[`skillStaticPage__congratulations__text__${index + 1}`]
              )}
            >
              {message}
            </p>
          ))}
        </div>
      </KitoMascot>
      <div className={styles.skillStaticPage__congratulations__back}>
        <KitoButton width="full" onClick={() => navigate('/new-skills')}>
          {t('staticPages.newSkills.congratulations.backToSkills')}
        </KitoButton>
      </div>
    </div>
  );
}

export default Congratulations;
